import { resolveCountryCodeToAlpha2, resolveCountryCodeToDiallingCode } from '../countries'
// Those types are basically copy-pasted from @reward-platform/members-api-client

// Maybe ideally we should have a type:types lib centralising those types
// but with the way that it's currently configured trying to import types here
// violates @nx/enforce-module-boundaries https://nx.dev/features/enforce-module-boundaries

type MemberTypesCountryOfResidenceLocation = {
  type: string
  identifier: string
}

type MemberTypesTelecomAddress = {
  deviceType: string
  type: string
  preferenceIndicator?: boolean
  number?: string
  areaCode?: string
  countryDiallingCode?: string
  platformType?: string
}

export const getAccountHolderPhoneNumber = (
  telecomAddresses?: Partial<MemberTypesTelecomAddress>[],
  countryOfResidence?: MemberTypesCountryOfResidenceLocation
): { dialingCode?: number; countryCode?: string; value: string } | undefined => {
  try {
    const telecomAddress =
      telecomAddresses?.find(({ preferenceIndicator }) => preferenceIndicator) ??
      telecomAddresses?.find(({ deviceType }) => deviceType === 'MOBILE') ??
      telecomAddresses?.find(({ deviceType }) => deviceType === 'PHONE') ??
      telecomAddresses?.[0]

    const countryDiallingCode = telecomAddress?.countryDiallingCode?.replace(/\D/g, '')

    const dialingCode =
      resolveCountryCodeToDiallingCode(Number(countryDiallingCode || '')) ??
      resolveCountryCodeToDiallingCode(countryOfResidence?.identifier)

    const countryCode =
      resolveCountryCodeToAlpha2() ?? resolveCountryCodeToAlpha2(countryOfResidence?.identifier)
    if (!telecomAddress?.number) {
      return undefined
    }

    return { dialingCode, countryCode, value: telecomAddress.number.replace(/\D+/g, '') }
  } catch (error) {
    return undefined
  }
}
